/**
 * registerService
 *
 * @package                onboard
 * @subpackage             registerService
 * @category               Service
 * @DateOfCreation         28 sept 2019
 * @ShortDescription       This is responsible for calling all api related to online registration
 */
import axios from 'axios';
import { configConstants } from '../_constants';


export const registerService = {
    userSave,
    getJobTitle,
    getBusinessLocation
};

/**
 * @DateOfCreation        28 sept 2019
 * @ShortDescription      This function is responsible to call Fetch online registration api
 * @param                 JSON jsonObj
 * @return                Response JSON jsonObj
 */

function userSave(detail)
{
    var bodyData = {};
    bodyData.businessId=detail.businessId;
    bodyData.locationId=detail.locationId;
    bodyData.firstName=detail.firstName;
    bodyData.lastName=detail.lastName;
    bodyData.emailId=detail.emailId;
    bodyData.dob=detail.dob;
    bodyData.jobTitleId=detail.jobTitleId;
    bodyData.phoneNumber=detail.phoneNumber;
    bodyData.streetAddress=detail.streetAddress;
    bodyData.city=detail.city;
    bodyData.state=detail.state;
    bodyData.zip=detail.zip;
    bodyData.workHistory=detail.workHistory;
    bodyData.availabilitySlots=detail.availabilitySlots;

    let bodyFormData = new FormData();
    bodyFormData.append('model', JSON.stringify(bodyData));
    bodyFormData.append('docFile',detail.docFile);


    
// for (const item in detail.availabilitySlots) 
// {
//     // instead of passing this.arrayValues.toString() iterate for each item and append it to form.
//     formData['availabilitySlots'],JSON.stringify(detail.availabilitySlots[index]));
// }

    return axios({
            method  : 'post',
            url     : configConstants.API_BASE_PATH+'OnlineApplication/Create',
            data    : bodyFormData,
            config: { headers: {'Content-Type': 'multipart/form-data',Pragma: 'no-cache' }}
        }).then(function (response) {
            return response;
        }).catch(function (response) {
            return response;
        });
}

/**
 * @DateOfCreation        28 sept 2019
 * @ShortDescription      This function is responsible to call Fetch master job title api
 * @param                 JSON jsonObj
 * @return                Response JSON jsonObj
 */
function getJobTitle() { 
    return axios({
            method  : 'get',
            url     : configConstants.API_BASE_PATH+'account/GetJobTitle',
        }).then(function (response) {
            return response;
        }).catch(function (response) {
            return response;
        });
}

/**
 * @DateOfCreation        28 sept 2019
 * @ShortDescription      This function is responsible to call Fetch business detail
 * @param                 JSON jsonObj
 * @return                Response JSON jsonObj
 */

function getBusinessLocation(slug) { 
    return axios({
            method  : 'get',
            url     : configConstants.API_BASE_PATH+'OnlineApplication/Get/'+slug,
        }).then(function (response) {
            return response;
        }).catch(function (response) {
            return response;
        });
}